export default __webpack_public_path__ + "static/we-391734c1000dc3059908e728bd844931.webp";